<script lang="ts" setup>
import imageNotFound from '@/assets/images/error-not-found.webp'
</script>

<template>
  <div data-test-id="not-found-error" class="error-404">
    <div class="error-404__content">
      <div
        class="error-404__image-container"
        data-test-id="not-found-image-container"
      >
        <nuxt-img
          class="error-404__image"
          :src="imageNotFound"
          alt="Страница не найдена"
          data-test-id="not-found-image"
        />
      </div>

      <div class="error-404__text" data-test-id="not-found-text">
        Страница не найдена
      </div>

      <the-button to="/" data-test-id="not-found-button">На главную</the-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-404 {
  padding: 100px 0 82px;
  text-align: center;

  @include media('>=tablet') {
    padding: 195px 0 173px;
  }

  &__content {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-items: flex-start;

    .app-button {
      width: 200px;
    }
  }

  &__text {
    margin: 66px 0 40px;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    color: var(--ui-color-sandy-100);

    @include media('>=tablet') {
      margin: 126px 0 40px;
      font-size: 20px;
    }
  }

  &__image-container {
    width: 100%;
    max-width: 228px;
    filter: drop-shadow(0 17px 20px rgba(255, 255, 255, 0.5));

    @include media('>=tablet') {
      max-width: 522px;
      filter: drop-shadow(0 40px 40px rgba(255, 255, 255, 0.5));
    }
  }

  &__image {
    width: 100%;
    object-fit: cover;
  }
}
</style>
